import React, { useState } from 'react';
import ProfileInfo from '../Cards/ProfileInfo';
import { useNavigate } from 'react-router';
import Searchbar from '../SearchBar/Searchbar';
import Toast from '../Toast/Toast';

const Navbar = ({ userInfo, onSearchNote, handleClearSerch }) => {
  const [searchQuery, setsearchQuery] = useState('')
  const navigate = useNavigate();

  const [showToast, setShowToast] = useState({
    isShown: true,
    type: "add",
    message: "Login Successful!"
  })

  const showHandleToast = (message, type) => {
    setShowToast({
      isShown: true,
      type,
      message
    })
  }
  const handleToastClose = () => {
    setShowToast({
      isShown: false,
      message: ""
    })
  }

  const onlogout = () => {
    localStorage.clear();
    navigate('/login')
  }

  const handleSearch = () => {
    if (searchQuery) {
      onSearchNote(searchQuery)
    }
  }

  const ClearSearch = () => {
    setsearchQuery("");
    handleClearSerch();
  }

  return (
    <div className='flex items-center justify-between drop-shadow px-6 py-2 bg-white ' >
      <h1 className='font-bold text-2xl ml-6 py-2 text-black '>EchoNotes</h1>


      {userInfo ? <Searchbar
        value={searchQuery}
        onChange={({ target }) => { setsearchQuery(target.value) }}
        hanleSearch={handleSearch}
        onClearSearch={ClearSearch}
      /> : null}

      {userInfo ? <ProfileInfo userInfo={userInfo} onlogout={onlogout} /> : null}

      {userInfo ?
        <Toast
          onClose={handleToastClose}
          isShown={showToast.isShown}
          type={showToast.type}
          message={showToast.message}
        /> : null}
    </div>
  )
}

export default Navbar
